/**
 * Sugestões da busca do cabeçalho — porte de Viavini_Ai/js/autocomplete.js (Magento), mesmo painel
 * (.vv-ai-suggest) e comportamento (sem indisponíveis, como a busca da produção): a partir de 3 caracteres (espera 300 ms) mostra "Buscar por",
 * categorias, produtos (foto, nome, preço "De" riscado) e "Ver todos os resultados"; setas, Enter e
 * Esc no teclado. Fonte: busca preditiva do Shopify (/search/suggest.json) em vez da API de IA.
 */
(function () {
  'use strict';

  if (window.VvSearchSuggest) return;
  window.VvSearchSuggest = true;

  var MIN_CHARS = 3;
  var INPUTS = ['#vv-header-search-input', '#vv-mobile-search-input'];
  var T = {
    label: 'Sugestões de busca',
    loading: 'Buscando…',
    none: 'Nenhum resultado para',
    anyway: 'Buscar mesmo assim',
    searchFor: 'Buscar por',
    categories: 'Categorias',
    products: 'Produtos',
    all: 'Ver todos os resultados para'
  };
  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var panel = document.createElement('div');
  panel.className = 'vv-ai-suggest';
  panel.id = 'vv-ai-suggest-panel';
  panel.setAttribute('role', 'listbox');
  panel.setAttribute('aria-label', T.label);
  panel.style.display = 'none';

  var activeInput = null;
  var lastQuery = '';
  var timer = null;
  var controller = null;
  var activeIndex = -1;

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function isVisible() {
    return panel.style.display !== 'none';
  }

  // position: fixed + reposiciona em qualquer rolagem (no desktop o Horizon rola o .page-wrapper,
  // não a janela — o absolute da produção ficaria parado enquanto a página sobe)
  function position() {
    if (!activeInput) return;
    var r = activeInput.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.top = r.bottom + 4 + 'px';
    panel.style.left = r.left + 'px';
    panel.style.width = Math.max(260, r.width) + 'px';
  }

  function hide() {
    panel.style.display = 'none';
    panel.innerHTML = '';
    lastQuery = '';
    activeIndex = -1;
    if (activeInput) {
      activeInput.removeAttribute('aria-activedescendant');
      activeInput.setAttribute('aria-expanded', 'false');
    }
  }

  function show() {
    position();
    panel.style.display = '';
  }

  function paint(html) {
    panel.innerHTML = html;
    items().forEach(function (el, i) { el.id = 'vv-ai-opt-' + i; });
    if (activeInput) activeInput.setAttribute('aria-expanded', 'true');
    show();
  }

  function items() {
    return Array.prototype.slice.call(panel.querySelectorAll('a[role="option"]'));
  }

  var STOPWORDS = ['vinho', 'vinhos', 'para', 'pra', 'de', 'do', 'da', 'dos', 'das', 'com', 'e', 'o', 'a', 'os', 'as', 'um', 'uma', 'no', 'na', 'em'];
  function coreTerms(query) {
    return query.toLowerCase().split(/\s+/).filter(function (w) { return w && STOPWORDS.indexOf(w) === -1; }).join(' ');
  }

  function allUrl(query, action) {
    return (action || root + 'search') + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide';
  }

  function price(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : money.format(n);
  }

  function render(data, query, action) {
    activeIndex = -1;
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [];
    var categories = res.collections || [];
    var html = '';

    if (!products.length && !categories.length) {
      html = '<div class="vv-ai-suggest-empty">' + T.none + ' "' + esc(query) + '"</div>';
      html += '<a class="vv-ai-suggest-all" href="' + esc(allUrl(query, action)) + '" role="option">' + T.anyway + '</a>';
      paint(html);
      return;
    }

    html += '<a class="vv-ai-suggest-term" href="' + esc(allUrl(query, action)) + '" role="option">' + T.searchFor + ' "' + esc(query) + '"</a>';

    if (categories.length) {
      html += '<div class="vv-ai-suggest-group"><div class="vv-ai-suggest-title">' + T.categories + '</div><ul class="vv-ai-suggest-cats">';
      categories.forEach(function (c) {
        html += '<li><a href="' + esc(c.url) + '" role="option">' + esc(c.title) + '</a></li>';
      });
      html += '</ul></div>';
    }

    if (products.length) {
      html += '<div class="vv-ai-suggest-group"><div class="vv-ai-suggest-title">' + T.products + '</div><ul class="vv-ai-suggest-products">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var now = parseFloat(p.price_min || p.price);
        var old = parseFloat(p.compare_at_price_max);
        html += '<li><a href="' + esc(p.url) + '" role="option">'
          + '<span class="vv-ai-suggest-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="vv-ai-suggest-info">'
          + '<span class="vv-ai-suggest-name">' + esc(p.title) + '</span>'
          + '<span class="vv-ai-suggest-price">'
          + (old > now ? '<s>' + esc(price(old)) + '</s> ' : '')
          + esc(price(now)) + '</span>'
          + '</span></a></li>';
      });
      html += '</ul></div>';
    }

    html += '<a class="vv-ai-suggest-all" href="' + esc(allUrl(query, action)) + '" role="option">' + T.all + ' "' + esc(query) + '"</a>';
    paint(html);
  }

  function setActive(idx) {
    var list = items();
    if (!list.length) return;
    list.forEach(function (el) {
      el.classList.remove('vv-ai-suggest-active');
      el.setAttribute('aria-selected', 'false');
    });
    if (idx < 0) idx = list.length - 1;
    if (idx >= list.length) idx = 0;
    activeIndex = idx;
    var el = list[idx];
    el.classList.add('vv-ai-suggest-active');
    el.setAttribute('aria-selected', 'true');
    if (activeInput) activeInput.setAttribute('aria-activedescendant', el.id);
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  function query(input) {
    var q = (input.value || '').trim();
    if (q.length < MIN_CHARS) {
      hide();
      return;
    }
    if (q === lastQuery && panel.children.length) {
      show();
      return;
    }
    lastQuery = q;
    activeInput = input;
    var form = input.closest('form');
    var action = form ? form.getAttribute('action') : '';

    panel.innerHTML = '<div class="vv-ai-suggest-loading">' + T.loading + '</div>';
    show();
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor';
    var opts = controller ? { signal: controller.signal } : {};
    fetch(url, opts)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        // Sem categoria para a frase inteira: tenta só as palavras que importam, como a busca da
        // produção ("vinho para churrasco" → Churrasco)
        var res = data && data.resources && data.resources.results;
        var core = coreTerms(q);
        if (!res || (res.collections || []).length || !core || core === q.toLowerCase()) return data;
        return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(core)
          + '&resources[type]=collection&resources[limit]=8', opts)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (extra) {
            var found = extra && extra.resources && extra.resources.results.collections;
            if (found && found.length) res.collections = found;
            return data;
          })
          .catch(function () { return data; });
      })
      .then(function (data) {
        if (!data) { hide(); return; }
        if (activeInput === input && (input.value || '').trim() === q) render(data, q, action);
      })
      .catch(function (e) {
        if (!e || e.name !== 'AbortError') hide();
      });
  }

  function attach(input) {
    if (!input || input.dataset.vvSuggest) return;
    input.dataset.vvSuggest = '1';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'vv-ai-suggest-panel');
    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { query(input); }, 300);
    });
    input.addEventListener('focus', function () {
      activeInput = input;
      if ((input.value || '').trim().length >= MIN_CHARS && panel.children.length) show();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hide();
        return;
      }
      if (!isVisible()) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter') {
        var list = items();
        if (activeIndex >= 0 && list[activeIndex]) {
          e.preventDefault();
          window.location.href = list[activeIndex].getAttribute('href');
        }
      }
    });
  }

  function init() {
    if (!panel.isConnected) document.body.appendChild(panel);
    INPUTS.forEach(function (sel) { attach(document.querySelector(sel)); });
  }

  panel.addEventListener('mouseover', function (e) {
    var a = e.target.closest('a[role="option"]');
    if (a) setActive(items().indexOf(a));
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vv-ai-suggest')) return;
    if (INPUTS.some(function (sel) { return e.target.matches && e.target.matches(sel); })) return;
    panel.style.display = 'none';
  });
  window.addEventListener('resize', function () { if (isVisible()) position(); });
  document.addEventListener('scroll', function () { if (isVisible()) position(); }, { passive: true, capture: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
